module.exports = __webpack_public_path__ + "static/media/download_roro.4690130a.png";